import { useBillingOrganization } from '@/hooks/billing/useBillingOrganization'
import { useEntitlementCheck } from '@/hooks/entitlements'
import { useActiveOrgHasCuiEnabled } from '@/hooks/organization/useActiveOrg'

export const useCanAccessVehicles = () => {
  const { data: billingOrg, isLoading: isLoadingBillingOrg } =
    useBillingOrganization()
  const { data: hasVehiclesEntitlement, isLoading: isLoadingEntitlement } =
    useEntitlementCheck({
      entitlement: 'vehicles',
      enabled: !!billingOrg,
    })
  const { data: hasCuiEnabled, isLoading: isLoadingCui } =
    useActiveOrgHasCuiEnabled()

  return {
    canAccessVehicles: hasVehiclesEntitlement === true,
    isBlockedForCui: hasCuiEnabled === true,
    isLoading: isLoadingBillingOrg || isLoadingEntitlement || isLoadingCui,
  }
}
